import React from 'react';

export const LinkPreviewSkeleton = () => {
  return (
    <div className="w-full max-w-md bg-white rounded-lg shadow-md overflow-hidden">
      <div className="animate-pulse">
        {/* Image skeleton */}
        <div className="h-48 bg-gray-200" />
        
        {/* Content skeleton */}
        <div className="p-4 space-y-4">
          {/* Title skeleton */}
          <div className="space-y-2">
            <div className="h-5 bg-gray-200 rounded w-3/4" />
            <div className="h-5 bg-gray-200 rounded w-1/2" />
          </div>
          
          {/* Description skeleton */}
          <div className="space-y-2">
            <div className="h-3 bg-gray-200 rounded w-full" />
            <div className="h-3 bg-gray-200 rounded w-5/6" />
            <div className="h-3 bg-gray-200 rounded w-4/6" />
          </div>
        </div>
      </div>
    </div>
  );
};